module.exports = __webpack_public_path__ + "media/images/icons/zoom-8d6dd90b3bb47871157a038e3669fb93.svg";